'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _functional = require('../utils/functional');

var _utils = require('../utils');

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accordion = {
  init: function init(_ref) {
    var el = _ref.el,
        context = _ref.context;

    this.selectors = (0, _helpers.createSelectors)({
      selectors: {
        itemsContainer: 'Items',
        item: 'Item',
        trigger: 'Trigger',
        body: 'Body'
      },
      context: context
    });
    this.els = {
      el: el,
      itemsContainer: context.getElement(this.selectors.itemsContainer),
      items: context.getElements(this.selectors.item)
    };
    this.options = {
      initialState: this.els.el.dataset.initialState,
      openOneAtATime: this.els.el.dataset.openOneAtATime === 'true'
    };
    this.listeners = (0, _create2.default)(_helpers.Listeners);

    this.isAnimating = false;

    this.items = this.buildItems();

    if (this.options.initialState === 'closedButFirstOpen') {
      this.items[0].isOpen = true;
    }

    this.handleClick = this.handleClick.bind(this);

    this.setupListeners();
  },

  handleClick: function handleClick(_ref2) {
    var target = _ref2.target;

    if (target.matches(this.selectors.trigger) === false || this.isAnimating) {
      return;
    }

    var item = this.items.find(function (item) {
      return item.els.trigger === target;
    });
    item.isOpen = !item.isOpen;
  },

  setupListeners: function setupListeners() {
    this.listeners.add(this.els.el, 'click', this.handleClick);
  },

  buildItems: function buildItems() {
    var _this2 = this;

    var _this = this;

    return this.els.items.map(function (el) {
      return {
        els: {
          el: el,
          trigger: (0, _functional.getElement)(_this2.selectors.trigger, { context: el }),
          body: (0, _functional.getElement)(_this2.selectors.body, { context: el })
        },
        _isOpen: false,
        get isOpen() {
          return this._isOpen;
        },

        set isOpen(val) {
          var _this3 = this;

          this._isOpen = val;

          _this.isAnimating = true;

          if (val) {
            this.els.el.setAttribute('aria-expanded', String(val));
            (0, _utils.slideDown)(this.els.body, Accordion.getBodyHeight(this.els.body)).then(function () {
              return _this.isAnimating = false;
            });

            if (_this.options.openOneAtATime === true) {
              _this.items.filter(function (item) {
                return item.els.el !== _this3.els.el;
              }).forEach(function (item) {
                return item.isOpen = false;
              });
            }
          } else {
            (0, _utils.slideUp)(this.els.body, Accordion.getBodyHeight(this.els.body)).then(function () {
              _this3.els.el.setAttribute('aria-expanded', String(val));
              _this3.els.body.removeAttribute('style');
              _this.isAnimating = false;
            });
          }
        }
      };
    });
  },

  getBodyHeight: function getBodyHeight(el) {
    el.style.display = 'block';
    var style = window.getComputedStyle(el);
    var height = el.offsetHeight + parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    el.style.display = '';

    return height;
  }
};

function init(_ref3) {
  var el = _ref3.el,
      context = _ref3.context;

  var accordion = (0, _create2.default)(Accordion);
  accordion.init({ el: el, context: context });
}